import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@activecollab/components";

export const useConfirmDialogOption = (options) => {
  const { t } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const {
    onConfirmSuccess,
    onConfirmAction,
    dialogTitle = t("Leave conversation?"),
    dialogContent = t("You will no longer be a member of this conversation, and you will lose access to it."),
    confirmBtnText = t("Leave"),
    cancelBtnText = t("Cancel"),
  } = options;

  const onShowDialog = useCallback(() => {
    setShowConfirmModal(true);
  }, []);

  const handleCloseConfirmModal = useCallback(() => {
    setShowConfirmModal(false);
  }, []);

  const handleConfirmSuccess = useCallback(() => {
    typeof onConfirmSuccess === "function" && onConfirmSuccess();
    handleCloseConfirmModal();
    typeof onConfirmAction === "function" && onConfirmAction();
  }, [onConfirmSuccess, handleCloseConfirmModal, onConfirmAction]);

  const dialogTemplate = useMemo(() => {
    return (
      <ConfirmDialog
        open={showConfirmModal}
        dialogTitle={dialogTitle}
        dialogContent={dialogContent}
        confirmBtnText={confirmBtnText}
        cancelBtnText={cancelBtnText}
        onCancel={handleCloseConfirmModal}
        onConfirm={handleConfirmSuccess}
      />
    );
  }, [
    cancelBtnText,
    confirmBtnText,
    dialogContent,
    dialogTitle,
    handleCloseConfirmModal,
    handleConfirmSuccess,
    showConfirmModal,
  ]);

  return [onShowDialog, dialogTemplate];
};
